import queryString from 'query-string';
import _ from 'underscore';

import { parseSearch } from './parse-search';
import type {
  ODataEntityResource,
  ODataSearch,
  ODataVariables,
} from '../types';

const DEFAULT_PAGE_SIZE = 20;

export function composeSearchString(
  variables: ODataVariables,
  edmEntity: ODataEntityResource,
  isColl = true,
) {
  const { cursorIndex } = variables;
  const initialSearch = _.omit(variables, ['locator', 'cursorIndex', 'skip', 'options']);
  let search: ODataSearch = {
    top: DEFAULT_PAGE_SIZE,
    count: true,
    skip: cursorIndex,
    ...initialSearch as ODataSearch,
  };

  if (!isColl) {
    // $filter, $orderby, $count, $skip, and $top are only valid for collections.
    search = _.omit(search, ['filter', 'orderby', 'count', 'skip', 'top']);
  }

  const parsedSearch = parseSearch(search, edmEntity);
  const searchCompact = _.omit(
    parsedSearch,
    x => _.isNull(x) || _.isUndefined(x),
  );
  const searchString = _.isEmpty(searchCompact) ? '' : `?${queryString.stringify(searchCompact)}`;

  return searchString;
}
